
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"fill":"#363636","stroke-width":"0px"},attrs:{"d":"m47.2,3c7.6,0,13.8,4.8,13.8,10.8v36.4c0,3.1-1.6,5.3-2.9,6.6-2.7,2.7-6.6,4.2-10.9,4.2h-29.5c-8.1,0-14.7-5.2-14.7-11.5V13.8c0-5.9,6.2-10.8,13.8-10.8h30.4Zm0-3h-30.4C7.5,0,0,6.2,0,13.8v35.6c0,8.1,7.9,14.6,17.7,14.6h29.5c9.3,0,16.8-6.2,16.8-13.8V13.8c0-7.6-7.5-13.8-16.8-13.8Zm-5,44.6h-20.4c-2.6,0-4.7-2.1-4.7-4.7v-6.8c0-2.6,2.1-4.7,4.7-4.7h20.4c2.6,0,4.7,2.1,4.7,4.7v6.8c0,2.6-2.1,4.7-4.7,4.7Zm-20.4-13.1c-.9,0-1.7.8-1.7,1.7v6.8c0,.9.8,1.7,1.7,1.7h20.4c.9,0,1.7-.8,1.7-1.7v-6.8c0-.9-.8-1.7-1.7-1.7h-20.4Zm18.3-4.3h-16.3c-1.9,0-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4h16.3c1.9,0,3.4,1.5,3.4,3.4s-1.5,3.4-3.4,3.4Zm-16.3-3.8c-.2,0-.4.2-.4.4s.2.4.4.4h16.3c.2,0,.4-.2.4-.4s-.2-.4-.4-.4h-16.3Zm16.2-5.6c0-.8-.7-1.5-1.5-1.5h-13.1c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5h13.1c.8,0,1.5-.7,1.5-1.5Z"}})])
          )
        }
      }
    